import axiosAPI from "../config/axiosInstance";

export const getAllMappings = async () => {
  return axiosAPI("get", "mappings");
};

export const getAllProjects = async () => {
  return axiosAPI("get", "projects");
};

export const addNewMapping = async (mappingData) => {
  return axiosAPI("post", "mappings", mappingData);
};

export const deleteMappingById = async (id) => {
  return axiosAPI("delete", `mappings/${id}`);
};

export const getMappingsByProjectId = async (projectId) => {
  return axiosAPI("get", `mappings/projects/${projectId}`);
};

export const addNewProject = async (projectName) => {
  return axiosAPI("post", "projects", { projectName });
};

export const deleteProjectById = async (id) => {
  return axiosAPI("delete", `projects/${id}`);
};

export const getProjectsData = async () => {
  return axiosAPI("get", "allProjects");
};

export const updatExecutionCount = async () => {
  return axiosAPI("post", "mappings/updateExecutionCount");
};
